import(/* webpackMode: "eager" */ "/var/www/vibe/src/app/page.tsx");
